import React from 'react'
import { Card, ListGroup, Button } from 'react-bootstrap'
import './index.css'
import { Link } from 'react-router-dom'
import NotificationRow from './notificationRow'
import { NotificationModalRowProps } from './types'

function NotificationModal({
    target,
    setShow,
    notifications,
    readNotification,
}: {
    target: any
    setShow: any
    notifications: NotificationModalRowProps[]
    readNotification: (id: string | null) => void
}) {
    const ref = React.useRef(null)

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                ref.current &&
                !(ref.current as HTMLElement).contains(event.target as Node) &&
                event.target !== target
            ) {
                setShow(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    return (
        <div ref={ref}>
            <Card className="card-div">
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <Card.Title className="mb-0">Notifications</Card.Title>
                    <Button
                        variant="link"
                        className="text-muted"
                        onClick={() => readNotification(null)}
                    >
                        Mark all as read
                    </Button>
                </Card.Header>
                <ListGroup variant="flush">
                    {notifications.map((notification, index) => (
                        <NotificationRow
                            key={index}
                            {...notification}
                            readFunction={readNotification}
                        />
                    ))}
                </ListGroup>
                <Link to="/notification">
                    <Card.Footer className="text-center">
                        <Button variant="success" className="view-all">
                            VIEW ALL
                        </Button>
                    </Card.Footer>
                </Link>
            </Card>
        </div>
    )
}

export default NotificationModal
